import React from 'react'

const ChatForumComp = (props) => {
    // console.log(props)
    return (
        <>
            {
                props?.chats.map((chat, index) =>
                    chat?.flagMsg === "others" ?
                        <>
                            {/*begin::Message(in)*/}
                            <div className="d-flex justify-content-start mb-10">
                                {/*begin::Wrapper*/}
                                <div className="d-flex flex-column align-items-start">
                                    {/*begin::User*/}
                                    <div className="d-flex align-items-center mb-2">
                                        {/*begin::Details*/}
                                        <div className="ms-3">
                                            <a href="#" className="fs-5 fw-bolder text-gray-900 text-hover-primary me-1">{chat?.createdBy}</a>
                                            <span className="text-muted fs-7 mb-1">
                                                {chat?.createdAt}
                                            </span>
                                        </div>
                                        {/*end::Details*/}
                                    </div>
                                    {/*end::User*/}
                                    {/*begin::Text*/}
                                    <div className="p-5 rounded bg-light-primary text-dark fw-bold mw-lg-400px text-start" data-kt-element="message-text">
                                        {chat?.text}
                                    </div>
                                    {/*end::Text*/}
                                </div>
                                {/*end::Wrapper*/}
                            </div>
                            {/*end::Message(in)*/}
                        </>
                        :
                        <>
                            {/*begin::Message(out)*/}
                            <div className="d-flex justify-content-end mb-10">
                                {/*begin::Wrapper*/}
                                <div className="d-flex flex-column align-items-end">
                                    {/*begin::User*/}
                                    <div className="d-flex align-items-center mb-2">
                                        {/*begin::Details*/}
                                        <div className="me-3">
                                            <span className="text-muted fs-7 mb-1">
                                                {chat?.createdAt}
                                            </span>
                                            <a href="#" className="fs-5 fw-bolder text-gray-900 text-hover-primary ms-1">
                                                {chat?.createdBy}
                                            </a>
                                        </div>
                                        {/*end::Details*/}
                                    </div>
                                    {/*end::User*/}
                                    {/*begin::Text*/}
                                    <div className="p-5 rounded bg-light-success text-dark fw-bold mw-lg-400px text-end" data-kt-element="message-text">
                                        {chat?.text}
                                    </div>
                                    {/*end::Text*/}
                                </div>
                                {/*end::Wrapper*/}
                            </div>
                            {/*end::Message(out)*/}
                        </>
                )
            }
        </>
    )
}

export default ChatForumComp
